import React, { ReactElement } from 'react';
import styled from '@emotion/styled';
import { ITheme, Markdown } from '../../../../../../ui';
import themed from '../../../../../../ui/themer/themed';

interface IFeaturesProps {
	features: string[];
}

export const Features = ({ features }: IFeaturesProps) => (
	<ul>
		{features.map((feature) => (
			<Item key={feature}>
				<Markdown source={feature} />
			</Item>
		))}
	</ul>
);

const Item = styled.li<{}, ITheme>`
	color: ${themed(
		(
			{ color },
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			props: any,
		) =>
			hasBoldText(props.children as ReactElement)
				? color.state.error
				: color.text.default,
	)};
`;

function hasBoldText(children?: ReactElement) {
	return /^\*\*.+\*\*$/.test(children?.props?.source ?? '');
}
